/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {HISTORY_EVENT_ICON_BY_ASSET} from '../maps/constants';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Stop Icon component.
 */
export const HarshEventIcon = (props: IconProps) => {
  const {iconSize}   = useIconDLS(props);
  const {harshEvent} = HISTORY_EVENT_ICON_BY_ASSET;

  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path fillRule='evenodd' clipRule='evenodd' d='M8 0C3.58172 -3.86257e-07 3.86258e-07 3.58172 0 8C-3.86258e-07 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 3.86259e-07 8 0ZM3.79946 5.19971L13.0002 8.00049L3.79946 10.7997L5.00024 8.00049L3.79946 5.19971Z'
        fill={harshEvent.color} />
    </svg>
  );
};
